/* eslint-disable max-statements */
import {useEffect, useState} from 'react';
import {passportDigits} from '../../../constants/commons';
import {dataNames} from '../../../constants/dataNames';
import {formValidations} from '../../../constants/formValidations';
import {formFloatInvErrors} from '../../../constants/initialErrors';
import {UserGroup} from '../../../constants/userGroup';
import {completeWithCeros, mapListToDropdownList} from '../../../utils/commonUtils';
import {fieldHasError, generateDataByTable, generateTimeLine} from '../../../utils/formUtils';

export const useModalOrderInfo = ({
  addMessageBoxError,
  advisersList,
  currentLineOriginal,
  dealerId,
  isUserTde,
  listDealers,
  minValue,
  putFloatingInventory,
  currentLine,
  setCurrentLine,
  currentLineError,
  setCurrentLineError,
  setCurrentFloatingLine,
  userEmail,
  currentClient,
  currentFlUserGroup,
  setCurrentFloatingOrderClient,
  filters,
}) => {
  const timeLine = generateTimeLine(currentLine);
  const [showClientDataModal, setShowClientDataModal] = useState(false);
  const [validating, setValidating] = useState(false);
  
  const handleChange = async(
    name,
    value,
    validations = [],
    extraData = {}
  ) => {
    const validationsArray = [...validations];
    let errorValue = {'value': value, 'error': false};
    for (let i = 0; i < validationsArray.length; i++) {
      errorValue = await validationsArray[i](errorValue.value, extraData);
      if (errorValue.error) {
        break;
      }
    }

    if (value?.length === 0) {
      setCurrentLine((prev) => ({...prev, [name]: errorValue?.value}));
    }
    if (errorValue?.error) {
      setCurrentLine((prev) => ({...prev, [name]: errorValue?.value}));
      setCurrentLineError((prev) => ({
        ...prev,
        [`${name}Error`]: errorValue?.error,
      }));
    } else {
      setCurrentLine((prev) => ({...prev, [name]: errorValue?.value}));
      setCurrentLineError((prev) => ({
        ...prev,
        [`${name}Error`]: errorValue?.error,
      }));
    }
  };

  const handleInputTextChange = (e, {name, value}, validation, extraData = null) => {
    const caret = e.target.selectionStart;
    const element = e.target;
    window.requestAnimationFrame(() => {
      element.selectionStart = caret;
      element.selectionEnd = caret;
    });
    handleChange(name, value, validation, extraData);
  };

  const save = (isUpdateClient = false) => {
    const dataByTable = generateDataByTable(currentLine, userEmail);
    const message = currentLine.floatingState === 'S' ?
      'Su solicitud de nacionalización ha sido guardada con éxito' :
      'Su reserva ha sido guardada con éxito';
    putFloatingInventory(
      currentLine.orderNumber,
      currentLine.line,
      {
        'all': isUserTde ? 'S' : 'N',
        'data': dataByTable,
        'updateClient': isUpdateClient,
        'dealerReservation': dealerId,
      },
      filters,
      message
    );
  };

  const percDiscHasMinError = () => {
    if (parseInt(currentLine.discapacityPerc, 10) < minValue || parseInt(currentLine.discapacityPerc, 10) > 100) {
      return true;
    }
    return false;
  };

  const didCustomFiledsChange = ({previuosData, currentData, fields}) => {
    let hasChanged = false;
    fields.forEach((field) => {
      if (String(previuosData[field]) !== String(currentData[field])) {
        hasChanged = true;
      }
    });
    return hasChanged;
  };
  
  useEffect(() => {
    if (currentLine.documentType === 'P') {
      currentLine.document && handleChange(
        'document',
        completeWithCeros(currentLine.document, passportDigits),
        formValidations.document(currentLine)
      );
    }
  }, [currentLine.documentType]);

  useEffect(() => {
    setCurrentFloatingOrderClient(currentLine.document);
  }, [currentLine.document]);

  const handleValidateChange = async(
    name,
    value,
    validations = [],
    extraData = {}
  ) => {
    const validationsArray = [...validations];
    let errorValue = {'value': value, 'error': false};
    for (let i = 0; i < validationsArray.length; i++) {
      errorValue = validationsArray[i](errorValue.value, extraData);
      if (errorValue.error) {
        break;
      }
    }

    if (errorValue?.error) {
      await setCurrentLineError((prev) => ({
        ...prev,
        [`${name}Error`]: errorValue?.error,
      }));
    } else {
      await setCurrentLineError((prev) => ({
        ...prev,
        [`${name}Error`]: false,
      }));
    }
  };
  const handleSave = async() => {
    setValidating(true);
    
    const dataEntries = Object.keys(formValidations);
    let errors = '';
    for (let i = 0; i < dataEntries.length; i++) {
      const value = currentLine[dataEntries[i]];
      if (dataEntries[i]) {
        const validations = formValidations[dataEntries[i]](currentLine);
        if (fieldHasError(value, validations)) {
          errors += `${dataNames[dataEntries[i]]} \n`;
        }
        if (dataEntries[i] === 'discapacityPerc' && percDiscHasMinError()) {
          errors += `${dataNames[dataEntries[i]]} \n`;
        }
      }
    }
    if (!errors) {
      setCurrentFloatingLine({'data': currentLine, isUserTde, dealerId});
      const fieldsChange = didCustomFiledsChange({
        'previuosData': currentLineOriginal,
        'currentData': currentLine,
        'fields': ['clientType', 'discapacityPerc', 'exonerationPerc'],
      });
      if (fieldsChange && currentLine?.id && currentLine?.document === currentClient) {
        setShowClientDataModal(true);
      } else {
        save(false);
      }
    } else {
      addMessageBoxError(`CORREGIR LOS CAMPOS:\n${errors}`);
      for (let i = 0; i < dataEntries.length; i++) {
        const value = currentLine[dataEntries[i]];
        if (dataEntries[i]) {
          const validations = formValidations[dataEntries[i]](currentLine);
          handleValidateChange(dataEntries[i], value, validations, {minValue});
        }
      }
    }
    setValidating(false);
  };

  const [advisersListDD, setListAdvisersDD] = useState(
    mapListToDropdownList(
      advisersList,
      {
        'keys': ['code'],
        'values': ['code'],
        'texts': ['name'],
      },
      false
    )
  );

  useEffect(() => {
    setListAdvisersDD(
      mapListToDropdownList(
        advisersList,
        {
          'keys': ['code'],
          'values': ['code'],
          'texts': ['name'],
        },
        false
      )
    );
  }, [advisersList]);

  useEffect(() => {
    setCurrentLine({
      ...currentLineOriginal,
      'floatingState': currentLineOriginal?.floatingState === 'D' ? 'R' : (currentLineOriginal?.floatingState || ''),
    });
  }, [currentLineOriginal]);

  useEffect(() => {
    return () => {
      setCurrentLine(formFloatInvErrors);
    };
  }, []);

  const listDealersDD = mapListToDropdownList(
    listDealers,
    {
      'keys': ['identification'],
      'values': ['identification'],
      'texts': ['name'],
    },
    false
  );

  const isAvailable = (isUserTde ||
    (dealerId === currentLine.dealerReservation && currentLine.floatingState === 'R') ||
    currentLine.floatingState === 'D') &&
    currentLine.floatingVisible === 'S' &&
    ([UserGroup.coachDealer, UserGroup.tdeUser].includes(currentFlUserGroup)) &&
    ['E', 'P'].includes(currentLine.status);

  const passedSolNac = ['S', 'L', 'V'].includes(currentLine.floatingState) &&
    ['S', 'L', 'V'].includes(currentLineOriginal.floatingState);
  return {
    'actions': {
      handleChange,
      handleSave,
      setShowClientDataModal,
      setValidating,
      save,
      setCurrentLine,
      handleInputTextChange,
    },
    'dataValues': {
      timeLine,
      advisersListDD,
      listDealersDD,
      isAvailable,
      showClientDataModal,
      validating,
      currentLine,
      currentLineError,
      passedSolNac,
    },
  };
};
